import { MutationHookOptions, useMutation } from '@apollo/client';
import { REMOVE_OFFER_MEMBERS_MUTATION } from '../queries';
import { RemoveMembers, RemoveMembersVariables } from '../queries/types/RemoveMembers';

type TOptions = MutationHookOptions<RemoveMembers, RemoveMembersVariables>;

export const useDeleteAffiliateFromAnOffer = (options: TOptions = {}) =>
  useMutation<RemoveMembers, RemoveMembersVariables>(REMOVE_OFFER_MEMBERS_MUTATION, options);
